import React from "react";
import { addEmployee, updateEmployee } from "../../api/employeeApi";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Step5BankingDetails = ({ formData, handleChange, nextStep, prevStep }) => {
  const navigate = useNavigate();

  const { id } = useParams();
  const isEditMode = Boolean(id); // <-- Adjust to your ID field

  const handleSave = async () => {
    try {
      const payload = {
  ...formData,
  designationID: Number(formData.designationID),
  departmentID: Number(formData.departmentID),
  educationID: Number(formData.educationID),
  gradeId: Number(formData.gradeId),
  sectionID: Number(formData.sectionID),
  basicSalary: Number(formData.basicSalary),
  grossSalary: Number(formData.grossSalary),
  totalAllow: Number(formData.totalAllow),
  totalDeduction: Number(formData.totalDeduction),
  netSalary: Number(formData.netSalary),
  perDaySalary: Number(formData.perDaySalary),
  allowance: {
    ...formData.allowance,
    allowance1: Number(formData.allowance.allowance1),
    allowance2: Number(formData.allowance.allowance2),
    allowance3: Number(formData.allowance.allowance3),
    allowance4: Number(formData.allowance.allowance4),
    allowance5: Number(formData.allowance.allowance5),
    allowance6: Number(formData.allowance.allowance6),
    allowance7: Number(formData.allowance.allowance7),
    allowance8: Number(formData.allowance.allowance8),
    allowance9: Number(formData.allowance.allowance9),
    allowance10: Number(formData.allowance.allowance10),
    allowance11: Number(formData.allowance.allowance11),
    allowance12: Number(formData.allowance.allowance12),
    allowance13: Number(formData.allowance.allowance13),
    allowance14: Number(formData.allowance.allowance14),
    allowance15: Number(formData.allowance.allowance15),
  },
  deduction: {
    ...formData.deduction,
    deduction1: Number(formData.deduction.deduction1),
    deduction2: Number(formData.deduction.deduction2),
    deduction3: Number(formData.deduction.deduction3),
    deduction4: Number(formData.deduction.deduction4),
    deduction5: Number(formData.deduction.deduction5),
    deduction6: Number(formData.deduction.deduction6),
    deduction7: Number(formData.deduction.deduction7),
    deduction8: Number(formData.deduction.deduction8),
    deduction9: Number(formData.deduction.deduction9),
    deduction10: Number(formData.deduction.deduction10),
    deduction11: Number(formData.deduction.deduction11),
    
  },
  familyDetails: {
    FatherHusbandName: formData.familyDetails.fatherHusbandName || null,
    FatherHusbandDOB: formData.familyDetails.fatherHusbandDOB || null,
    FatherHusbandRelation: formData.familyDetails.fatherHusbandRelation || null,
    MotherWifeName: formData.familyDetails.motherWifeName || null,
    MotherWifeDOB: formData.familyDetails.motherWifeDOB || null,
    MotherWifeRelation: formData.familyDetails.motherWifeRelation || null,
    Child1Name: formData.familyDetails.child1Name || null,
    Child1Gender: formData.familyDetails.child1Gender || null,
    Child1DOB: formData.familyDetails.child1DOB || null,
    Child2Name: formData.familyDetails.child2Name || null,
    Child2Gender: formData.familyDetails.child2Gender || null,
    Child2DOB: formData.familyDetails.child2DOB || null,
  }
};

      console.log("Submitting final form data:", payload);
//       const payload = { ...formData };
// delete payload.employeeCode; 
      const response = await addEmployee(payload); // call API
      // alert("Employee added successfully!");
      alert(response.message || "Employee added successfully!");
      //  navigate to WelcomePage page here 
      navigate("/welcome");
    } catch (error) {
      console.error("Error:", error);
      alert(error.message);
      // alert("Failed to add employee.");
    }
  };

  const handleUpdate = async () => {
  // Helper to convert yyyy-MM-dd to yyyy-MM-ddTHH:mm:ss
  const toApiDate = (dateStr) => {
    if (!dateStr) return null;
    return new Date(dateStr).toISOString().split('.')[0]; // remove milliseconds
  };


  // Prepare clean data for API
  const cleanedFormData = {
    ...formData,
     trUser: "admin", 
    trDate: new Date().toISOString(),
    birthDate: toApiDate(formData.birthDate),
    joiningDate: toApiDate(formData.joiningDate),
    retirementDate: toApiDate(formData.retirementDate),
    exitDate: toApiDate(formData.exitDate),
    reJoiningDate: toApiDate(formData.reJoiningDate),
    crDate: toApiDate(formData.crDate),
    familyDetails: {
      ...formData.familyDetails,
      fatherHusbandDOB: toApiDate(formData.familyDetails?.fatherHusbandDOB),
      motherWifeDOB: toApiDate(formData.familyDetails?.motherWifeDOB),
      child1DOB: toApiDate(formData.familyDetails?.child1DOB),
      child2DOB: toApiDate(formData.familyDetails?.child2DOB),

    }
  };

  try {
    // const normalizeEmployeeData1 = normalizeEmployeeData(formData);
    console.log("Employee updated :", cleanedFormData);
    const response = await updateEmployee(id, cleanedFormData);
    // const response = await updateEmployee(id, normalizeEmployeeData1);
    console.log("Employee updated successfully:", response);
    alert("Employee Update successfully!");
      //  navigate to WelcomePage page here 
      navigate("/welcome");
  } catch (error) {
    console.error("Error updating employee:", error);
  }
};

  return (
    <div className="container mt-4">
      {/* <div className="card mb-4">
      <h3 className="bg-success text-white p-2">Bank & Statutory Details</h3> */}
      <div className="card mb-4">
        <div className="bg-success text-white p-2 d-flex justify-content-between align-items-center">
          <span>Bank & Statutory Details</span>
          <span>
            {formData.fName} {formData.lName}
          </span>
        </div>
      <div className="row g-3">
        <div className="col-md-6">
          <label>Bank Account No.</label>
          <input
            type="text"
            className="form-control"
            value={formData.bankAccountNo}
            maxLength={30} // limit input length to 30
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters and digits
              const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
              if (filteredValue.length <= 30) {
                handleChange("bankAccountNo")({ target: { value: filteredValue } });
              }
            }}
          />
        </div>
        <div className="col-md-6">
          <label>IFSC Code</label>
          <input
            type="text"
            className="form-control"
            value={formData.ifscCode}
            // onChange={handleChange("ifscCode")}
            maxLength={20} // limit input length to 30
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters and digits
              const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
              if (filteredValue.length <= 20) {
                handleChange("ifscCode")({ target: { value: filteredValue } });
              }
            }}
          />
        </div>
        <div className="col-md-4">
          <label>PF Account No.</label>
          <input
            type="text"
            className="form-control"
            value={formData.pfAccountNo}
            maxLength={30} // limit input length to 30
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters and digits
              const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
              if (filteredValue.length <= 30) {
                handleChange("pfAccountNo")({ target: { value: filteredValue } });
              }
            }}
            // onChange={handleChange("pfAccountNo")}
          />
        </div>
        <div className="col-md-4">
          <label>UAN No.</label>
          <input
            type="text"
            className="form-control"
            value={formData.uanNo}
            maxLength={30} // limit input length to 30
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters and digits
              const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
              if (filteredValue.length <= 30) {
                handleChange("uanNo")({ target: { value: filteredValue } });
              }
            }}
            // onChange={handleChange("uanNo")}
          />
        </div>
        <div className="col-md-4">
          <label>ESIC No.</label>
          <input
            type="text"
            className="form-control"
            value={formData.esicNo}
            maxLength={30} // limit input length to 30
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters and digits
              const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
              if (filteredValue.length <= 30) {
                handleChange("esicNo")({ target: { value: filteredValue } });
              }
            }}
            // onChange={handleChange("esicNo")}
          />
        </div>
        <div className="col-md-4">
          <label>Gratuity No.</label>
          <input
            type="text"
            className="form-control"
            value={formData.gratuityNo}
            maxLength={30} // limit input length to 30
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters and digits
              const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
              if (filteredValue.length <= 30) {
                handleChange("gratuityNo")({ target: { value: filteredValue } });
              }
            }}
            // onChange={handleChange("gratuityNo")}
          />
        </div>
        <div className="col-md-4">
          <label>MLWF Lin No.</label>
          <input
            type="text"
            className="form-control"
            value={formData.mlwfLinNo}
            maxLength={30} // limit input length to 30
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters and digits
              const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
              if (filteredValue.length <= 30) {
                handleChange("mlwfLinNo")({ target: { value: filteredValue } });
              }
            }}
            // onChange={handleChange("mlwfLinNo")}
          />
        </div>
      </div>
      </div>
      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={prevStep}>Previous</button>
        {/* <button className="btn btn-primary" onClick={nextStep}>Next</button> */}
        {/* <button className="btn btn-success" onClick={handleSubmit}>Save</button> */}

        {isEditMode ? (
          <button className="btn btn-warning" onClick={handleUpdate}>
            Update
          </button>
        ) : (
          <button className="btn btn-success" onClick={handleSave}>
            Save
          </button>
        )}
      </div>
    </div>
  );
};

export default Step5BankingDetails;






//   const normalizeEmployeeData =(data) =>{
//   return {
//     employeeID: Number(data.employeeID),
//     employeeCode: data.employeeCode,
//     fName: data.fName || "a",
//     mName: data.mName || "a",
//     lName: data.lName || "a",
//     gender: data.gender || "a",
//     birthDate: data.birthDate ? new Date(data.birthDate).toISOString() : null,
//     joiningDate: data.joiningDate ? new Date(data.joiningDate).toISOString() : null,
//     reJoiningDate: data.reJoiningDate ? new Date(data.reJoiningDate).toISOString() : null,
//     exitDate: data.exitDate ? new Date(data.exitDate).toISOString() : null,
//     retirementDate: data.retirementDate ? new Date(data.retirementDate).toISOString() : null,

//     designationID: Number(data.designationID) || 0,
//     departmentID: Number(data.departmentID) || 0,
//     educationID: Number(data.educationID) || 0,
//     gradeId: Number(data.gradeId) || 0,
//     sectionID: Number(data.sectionID) || 0,

//     employeeType: data.employeeType || "a",
//     empPassword: data.empPassword || "a",

//     aadharCardNumber: data.aadharCardNumber || "a",
//     nameOnAadharCard: data.nameOnAadharCard || "a",
//     panNo: data.panNo || "a",
//     uanNo: data.uanNo || "a",
//     pfAccountNo: data.pfAccountNo || "a",
//     esicNo: data.esicNo || "a",
//     gratuityNo: data.gratuityNo || "a",
//     mlwfLinNo: data.mlwfLinNo || "a",
//     passportNo: data.passportNo || "a",
//     drivingLicNo: data.drivingLicNo || "a",

//     phoneNo1: data.phoneNo1 || "a",
//     phoneNo2: data.phoneNo2 || "a",
//     emailId: data.emailId || "a",

//     permanentAddress: data.permanentAddress || "a",
//     presentAddress: data.presentAddress || "a",
//     city: data.city || "a",
//     state: data.state || "a",
//     district: data.district || "a",
//     taluka: data.taluka || "a",
//     country: data.country || "a",
//     pincode: data.pincode || "a",

//     bankAccountNo: data.bankAccountNo || "a",
//     ifscCode: data.ifscCode || "a",

//     // salary + calculations
//     basicSalary: Number(data.basicSalary) || 0,
//     grossSalary: Number(data.grossSalary) || 0,
//     netSalary: Number(data.netSalary) || 0,
//     totalAllow: Number(data.totalAllow) || 0,
//     totalDeduction: Number(data.totalDeduction) || 0,
//     perDaySalary: Number(data.perDaySalary) || 0,
//     age: Number(data.age) || 0,

//     calculatePF: data.calculatePF || "Y",
//     calculateESIC: data.calculateESIC || "Y",
//     calculatePT: data.calculatePT || "Y",
//     hraCalculation: data.hraCalculation || "Y",

//     // allowance object always present
//     allowance: {
//       allowance1: Number(data.allowance?.allowance1) || 0,
//       allowance2: Number(data.allowance?.allowance2) || 0,
//       allowance3: Number(data.allowance?.allowance3) || 0,
//       allowance4: Number(data.allowance?.allowance4) || 0,
//       allowance5: Number(data.allowance?.allowance5) || 0,
//       allowance6: Number(data.allowance?.allowance6) || 0,
//       allowance7: Number(data.allowance?.allowance7) || 0,
//       allowance8: Number(data.allowance?.allowance8) || 0,
//       allowance9: Number(data.allowance?.allowance9) || 0,
//       allowance10: Number(data.allowance?.allowance10) || 0,
//       allowance11: Number(data.allowance?.allowance11) || 0,
//       allowance12: Number(data.allowance?.allowance12) || 0,
//       allowance13: Number(data.allowance?.allowance13) || 0,
//       allowance14: Number(data.allowance?.allowance14) || 0,
//       allowance15: Number(data.allowance?.allowance15) || 0,
//     },

//     // deduction object always present
//     deduction: {
//       deduction1: Number(data.deduction?.deduction1) || 0,
//       deduction2: Number(data.deduction?.deduction2) || 0,
//       deduction3: Number(data.deduction?.deduction3) || 0,
//       deduction4: Number(data.deduction?.deduction4) || 0,
//       deduction5: Number(data.deduction?.deduction5) || 0,
//       deduction6: Number(data.deduction?.deduction6) || 0,
//       deduction7: Number(data.deduction?.deduction7) || 0,
//       deduction8: Number(data.deduction?.deduction8) || 0,
//       deduction9: Number(data.deduction?.deduction9) || 0,
//       deduction10: Number(data.deduction?.deduction10) || 0,
//       deduction11: Number(data.deduction?.deduction11) || 0,
//       deduction12: Number(data.deduction?.deduction12) || 0,
//       deduction13: Number(data.deduction?.deduction13) || 0,
//       deduction14: Number(data.deduction?.deduction14) || 0,
//       deduction15: Number(data.deduction?.deduction15) || 0,
//     },

//     // family details always present
//     familyDetails: {
//       fatherHusbandName: data.familyDetails?.fatherHusbandName || "a",
//       fatherHusbandDOB: data.familyDetails?.fatherHusbandDOB ? new Date(data.familyDetails.fatherHusbandDOB).toISOString() : null,
//       fatherHusbandRelation: data.familyDetails?.fatherHusbandRelation || null,
//       motherWifeName: data.familyDetails?.motherWifeName || "a",
//       motherWifeDOB: data.familyDetails?.motherWifeDOB ? new Date(data.familyDetails.motherWifeDOB).toISOString() : null,
//       motherWifeRelation: data.familyDetails?.motherWifeRelation || null,
//     },

//     maritalStatus: data.maritalStatus || "a",
//     bloodGroup: data.bloodGroup || "a",
//     previousExperience: data.previousExperience || "a",

//     deleted: data.deleted || "N",
//     crUser: data.crUser || "admin",
//     trDate: data.retirementDate ? new Date(data.trDate).toISOString() : null,
//     trDate: new Date(data.trDate).toISOString(),
//     trUser: data.trUser || "admin",
//   };
// }

